import React, { useState } from 'react';
import { Upload, Edit, Save, LogOut, Building } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const ProfileSidebar = ({
    studentData,
    isEditing,
    isLoading,
    onEdit,
    onSave,
    onCancel,
    onLogout,
    onProfileUploadClick,
    onResumeUpload,
    getProfileImageUrl,
    navigate
}) => {
    const imageUrl = studentData.profilePicPath
        ? getProfileImageUrl(studentData.profilePicPath)
        : null;
    // Tracks the URL that failed so a new URL is retried automatically
    const [failedUrl, setFailedUrl] = useState(null);

    const handleDownloadResume = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/download/${studentData.studentId}`,
                { responseType: 'blob' }
            );

            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', `${studentData.name}_${studentData.selectedDepartment}_${studentData.adminbranch}_Resume.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error downloading resume:', error);
        }
    };

    return (
        <div className="profile-sidebar">
            <h2 className="Stud-id">{studentData.studentId}</h2>

            <div className="profilesp-avatar">
                {imageUrl && failedUrl !== imageUrl ? (
                    <img
                        src={imageUrl}
                        alt="Profile"
                        className="profile-image"
                        onError={() => {
                            console.error('Image failed to load:', imageUrl);
                            setFailedUrl(imageUrl);
                        }}
                    />
                ) : (
                    <FontAwesomeIcon icon={faUser} className="user-icon" />
                )}

            </div>

            <input
                id="resume-upload"
                type="file"
                accept="application/pdf"
                onChange={onResumeUpload}
                style={{ display: "none" }}
            />

            <div className="sidebar-actions">
                <div className='sidebar-group'>
                    <button className="upload-btn" onClick={onProfileUploadClick}>
                        <Upload size={16} /> Upload Profile-Pic
                    </button>

                    <label className="sidebar-btn" htmlFor="resume-upload">
                        <Upload size={16} /> Upload Resume
                    </label>

                    {studentData.resumePath && (
                        <button className="sidebar-btn" onClick={handleDownloadResume}>
                            📄 Download Resume
                        </button>
                    )}

                    {/* {studentData?.placementneeded === "Yes" && (
                        <button
                            className="sidebar-btn"
                            onClick={() => navigate('/company-notifications')}
                        >
                            <Building size={16} />
                            View Company Notifications
                        </button>
                    )} */}
                </div>

                <div className='sidebar-group'>
                    {!isEditing ? (
                        <button className="sidebar-btn" onClick={onEdit}>
                            <Edit size={16} />
                            Edit Profile
                        </button>
                    ) : (
                        <div className="edit-actions">
                            <button
                                className="sidebar-btn save-btn"
                                onClick={onSave}
                                disabled={isLoading}
                            >
                                {isLoading ? "Saving..." : <><Save size={16} />Update</>}
                            </button>
                            <button
                                className="sidebar-btn cancel-btn"
                                onClick={onCancel}
                                disabled={isLoading}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileSidebar;